import React from "react";
import { Button, Modal, TableAdv } from "../../../../components";
import { mapTableRows } from "../../../../utils";


const RecivePaymentModal = ({ open, onClose }) => {

    const columns = [
        {
          key: "Select",
          label: "selcet",
        },
        {
          key: "Credit Memo",
          label: "Credit Memo",
        },
        {
          key: "Credit Available",
          label: "CreditAvailable",
        },
        {
          key: "PaymentDate",
          label: "Payment Date",
        }
      ];
      const tableData = [];
      const mappedRows = mapTableRows(tableData, columns);
      return (
        <Modal isOpen={open} onClose={onClose} title="AVAILABLE CREDITS" width="max-w-4xl">
          <div >
            <TableAdv
              tableId={`invoices_invoicedetails_receivepayments_receivepaymentmodel`}
              rows={mappedRows}
              columns={columns}
              hideToolBar
            />
            <div className="flex justify-end mt-4">
              <Button
                size="sm"
                title="Close"
                onClick={onClose}
              />
            </div>
          </div>
        </Modal>
      );
      
};

export default RecivePaymentModal;
